import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Patient } from "../../../utils/api-objects/Patient"
import { Folder } from "../../../utils/Enums"
import { FolderBox } from "./FolderBox"

interface UploadsProps {
    patient: Patient,
}

const UploadsBox: React.FC<UploadsProps> = ({
    patient,
}) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const navigate = useNavigate();

    const handleToggle = () => {
        setIsExpanded(prev => !prev);
    };
    return (
        <div className="space-y-[25px] border rounded-xl p-2 border border-solid border-holifya-grey-shadow shadow-platform-new">
            <div className="font-bold text-[16px] leading-[33px] flex justify-between items-center">
                <span>File condivisi</span>
                <button
                    onClick={handleToggle}
                    className="text-blue-500 text-sm">
                    {isExpanded ? "Mostra meno" : "Mostra di più"}
                </button>
            </div>
            {isExpanded && (<div className="space-y-[20px]">
                <FolderBox
                    folder={Folder.SharedFromEquipe}
                    pointer={true}
                    onClick={() => { navigate(`shared-from-equipe-page?patient_id=${patient.user_id}`) }}
                />
                <FolderBox
                    folder={Folder.SharedFromPatient}
                    pointer={true}
                    onClick={() => { navigate(`shared-from-customer-page?patient_id=${patient.user_id}`) }}
                    patient={patient}
                />
            </div>
            )}
        </div>
    )
}

export default UploadsBox
